export const fiatWalletKeys = {
  all: ['wallet', 'fiat'] as const,
  fiat: () => [...fiatWalletKeys.all, 'balance'] as const,
  slicealAccount: () => [...fiatWalletKeys.all, 'slicealAccount'] as const,
}
